import React from 'react';

import { HOMECARD_IMAGE_SIZES } from '../common/constants';
import { generateHomeCardLabels } from '../common/generateHomeCardLabels';

import Homecard from './Homecard';
import HomeCardBack from './HomeCardBack';
import './HomecardGrid.scss';

const generateImageSet = photoUrls =>
  Object.keys(photoUrls)
    .filter(size => photoUrls[size] && HOMECARD_IMAGE_SIZES[size])
    .map(size => `${photoUrls[size]} ${HOMECARD_IMAGE_SIZES[size]}`);

const HomecardGrid = ({ homecards = [] }) => (
  <div className="homecard-grid">
    {homecards.map(homecard => (
      <Homecard
        renderLabels={generateHomeCardLabels(homecard.checked)}
        imageSet={
          homecard.photoUrls ? generateImageSet(homecard.photoUrls) : ''
        }
        key={`${homecard.id}${homecard.title}`}
        rating={
          homecard.reviews && homecard.reviews.ratingAverage
            ? homecard.reviews.ratingAverage
            : null
        }
        title={homecard.title}
        price={{
          amount: homecard.monthlyPrice.minimumPrice,
          type: homecard.monthlyPrice.type,
          currencyCode: homecard.currencyIsoCode,
          monthly: true
        }}
        type={homecard.type}
        link={homecard.url}
        renderExtended={() => (
          <HomeCardBack
            thingsWeLike={homecard.thingsWeLike || []}
            thingsToKeepInMind={homecard.thingsToKeepInMind || []}
          />
        )}
        description={homecard.description}
      />
    ))}
  </div>
);

export default HomecardGrid;
